export const isObjectWithKey = (value: unknown): value is { key: string; type: string } => {
  return typeof value === 'object' && value !== null && ('key' in value || 'type' in value);
};
